"use strict";

/**
 * PLWIN is a framework for web developement in Prolog.
 * Copyright 2020-2021 Péter Tóth <peter@toth.dev>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

var jquery = require("jquery");
window.$ = window.jQuery = jquery;

import {Collapse, Modal, Tooltip} from 'bootstrap';

import Prism from 'prismjs';
Prism.manual = true;
Prism.languages.prolog.variable = /\b[A-Z_]\w*/;
Prism.languages.prolog.keyword = /\b(abolish|append|arg|asserta|assertz|at_end_of_stream|atom|atom_chars|atom_codes|atom_concat|atom_length|atomic|bagof|call|catch|char_code|char_conversion|clause|close|compound|copy_term|current_char_conversion|current_input|current_op|current_output|current_predicate|current_prolog_flag|fail|false|findall|float|flush_output|functor|get_byte|get_char|get_code|halt|integer|is|nl|nonvar|number|number_chars|number_codes|once|op|open|peek_byte|peek_char|peek_code|put_byte|put_char|put_code|read|read_term|repeat|retract|set_input|set_output|set_prolog_flag|set_stream_position|setof|stream_property|sub_atom|throw|true|unify_with_occurs_check|var|write|writeln|write_canonical|write_term|writeq)\b/;


var prolog_state = '[]';
var prolog_submit_action = null;
var prolog_unload_msg = null;

var plwin_backend_root;
var plwin_module_path;

$(document).ready(function(){
    window.addEventListener("error", handle_error);


    plwin_backend_root = $('link[rel="x-plwin-root"]').attr('data-href');
    if (plwin_backend_root == 'PLWIN_ROOT/') {
        console.warn('%cWARNING: The x-plwin-root link in the page should have been replaced by the PLWIN backend',
            'color: orange; font-weight: bold; font-size: 1.5em;',
        );
        plwin_backend_root = undefined;
    }

    console.log('%cPLWIN initialization started', 'font-size:2.5em');
    console.log('Loading:', document.location);
    navigate();

    $('body').on(
        'click', 'button.btn,a.plwin_btn',
        (evt) =>{
            submit_form(evt.currentTarget);
            return false;
        });
    $('body').on(
        'click', 'a',
        (evt) => {
            const href = $(evt.currentTarget).attr('href') ?? '';
            if (href.startsWith('?/')) {
                console.warn('URL starts with ?/');
                window.history.pushState(null, '', href);
                navigate();
                return false;
            }
        });

    $(document).on('input', 'input[type="range"]', (e) => {
        // display current value to the right of the range input element
        e.target.parentElement.querySelector('span:last-child').textContent = e.target.value
    });

    window.addEventListener('popstate',
        function(evt) {
            navigate();
            scroll_to_anchor();
            evt.preventDefault();
        });

    $('#_page_form').submit(function() {
        if (prolog_submit_action !== null) {
            submit_form(prolog_submit_action);
        }
        return false;
    });

    $(window).on('beforeunload', function() {
        if (prolog_unload_msg) {
            return prolog_unload_msg;
        }
    });
});

$(document).ready(function(){
    /**
     * Originally copied from the Bootstrap documentation licensed under CC-BY 3.0
     * https://getbootstrap.com/docs/5.3/customize/color-modes/#javascript
     */
    let storedTheme = localStorage.getItem('theme')

    const getPreferredTheme = () => {
        if (storedTheme) {
            return storedTheme
        }

        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    }

    const setTheme = function (theme) {
        if (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            document.documentElement.setAttribute('data-bs-theme', 'dark')
        } else {
            document.documentElement.setAttribute('data-bs-theme', theme)
        }
    }

    setTheme(getPreferredTheme())

    const showActiveTheme = theme => {
        const btnsToActive = document.querySelectorAll(`[data-bs-theme-value="${theme}"]`)

        document.querySelectorAll('[data-bs-theme-value]').forEach(element => {
            element.classList.remove('active', 'btn-primary')
            element.classList.add('btn-outline-primary')
        })

        btnsToActive.forEach(element => {
            element.classList.add('active', 'btn-primary')
            element.classList.remove('btn-outline-primary')
        })
    }

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        if (storedTheme !== 'light' && storedTheme !== 'dark') {
            setTheme(getPreferredTheme())
        }
    });

    window.addEventListener('storage', (evt) => {
        if (evt.key == 'theme') {
            const theme = evt.newValue;
            storedTheme = theme;
            setTheme(theme);
            showActiveTheme(theme);
        }
    });

    $(document).on('initial_done.plwin', () => {
        showActiveTheme(getPreferredTheme())
    })

    $('body').on(
        'click', '[data-bs-theme-value]',
        (evt) => {
            console.log(evt);
            const theme = $(evt.currentTarget).data('bs-theme-value')
            localStorage.setItem('theme', theme)
            setTheme(theme)
            showActiveTheme(theme)
            return false
        });
});


function navigate() {
    let path = document.location.pathname
    const prefix = plwin_backend_root + plwin_module_path + '/';
    if (path.startsWith(prefix)) {
        path = path.substring(prefix.length);
    }

    if (path == '') {
        path = 'index';
    }

    if (PageGen.initialized && PageGen.subpath == path) {
        // navigating to the same subpage
        return;
    }

    PageGen.subpath = path;

    get_result();
}


function submit_form(btn, extra_params={}) {
    const action =
        (typeof btn == 'string' || Array.isArray(btn))
        ? btn
        : btn.name;
    if (!action ) {
        return false;
    }

    var params = {};
    for (const field of $('#_page_form *').filter(':input')) {
        var fld = $(field);
        if (field.type == 'checkbox') {
            params[fld.attr("name")] = String(field.checked);
        } else if (field.type == 'radio') {
            if (fld.prop('checked')) {
                params[fld.attr("name")] = fld.val();
            }
        } else {
            params[fld.attr("name")] = fld.val();
        }
    }

    for (let hook of PageGen.form_data_hooks) {
        hook(params);
    }

    for (let key in extra_params) {
        params[key] = extra_params[key];
    }

    get_result(action, params)
    return false;
}
window.submit_form = submit_form;


function get_result(action=[], params={}) {
    if (PageGen.query_in_progress) {
        PageGen.action_queue.push([action, params]);
        return;
    }
    PageGen.query_in_progress = true;

    let path = document.location.pathname;
    if (path.startsWith(plwin_backend_root)) {
        path = path.substring(plwin_backend_root.length);
    } else {
        console.warn(`Current path ('${path}') is outside the root prefix: '${plwin_backend_root}'`);
    }

    disable_form(action);
    send_query(path, action, params);
}


function send_query(path, action, params) {
    let params_json = [];
    for (const [key, value] of Object.entries(params)) {
        params_json.push(
            {functor: '-', args: [key, value]} // TODO: compound value?
        );
    }
    const query_obj = {
        path: path,
        action: action,
        state: prolog_state,
        params: params_json,
    };
    console.log('%cQuery: ' + query_obj,
        'display: block; border: 3px solid #888; margin: 5px; padding: 3px; font-size: 1.3em; box-shadow: 10px 5px 5px red;');
    $.ajax({
        url: plwin_backend_root + '_api/send',
        method: 'POST',
        datatype:'json',
        contentType: 'application/json',
        data: JSON.stringify(query_obj),
    }).done((response, status) => {
        if (response.result.status == 'error') {
            handle_error(response.result.error);
            return;
        }
        if (plwin_module_path === undefined) {
            plwin_module_path = response.result.module;
        }
        display_result(response.result);
    }).fail((jqXHR, textStatus, errorThrown) => {
        let msg = errorThrown;
        if ('responseJSON' in jqXHR && 'message' in jqXHR.responseJSON) {
            msg += '\n\n';
            msg += jqXHR.responseJSON.message;
        }
        if (msg == '') {
            msg = 'Could not connect to backend';
        }
        handle_error({
            code: jqXHR.status, data: msg,
            type: 'Backend response'
        });
    });
}

function disable_form(action='') {
    if (PageGen.form_disabled) {
        return;
    }
    PageGen.form_disabled = true;

    $('input[type=button],input[type=submit],button').each(
        (_i, e) => {
            $(e).data('last_disabled', $(e).prop('disabled'));
            $(e).prop('disabled', true);
        });

    $('body').addClass('page-disabled');

    // display spinner in place of icon(s)
    if (Array.isArray(action)) {
        action = action[0];
    }
    const button = $(`.btn[name='${action}']`);
    if (button.length > 0) {
        const icons = button.children('.material-icons');
        if (icons.length > 0) {
            icons.css('display', 'none');
            icons.after('<span class="spinner-border spinner-border-sm mx-1"></span>');
            button.addClass('load-spinner-displayed');
        }
    }
}
function enable_form() {
    if (!PageGen.form_disabled) {
        return;
    }
    PageGen.form_disabled = false;

    $('input,button,select,textarea').each(
        (_i, e) => {
            if ($(e).data('last_disabled') === false) {
                $(e).prop('disabled', false);
            }
        });
    $('body').removeClass('page-disabled');

    const spinning = $('.load-spinner-displayed');
    spinning.children('.material-icons').css('display', '');
    spinning.children('.spinner-border').remove();
}


function display_result(result) {
    console.log('result.result:', result.result);
    const div = $('#_root')

    prolog_state = result.new_state;

    try {
        for (const res of result.result) {
            process_command(div, res, 'end');
        }

        if (!PageGen.initialized) {
            PageGen.initialized = true;
            console.log('%c PLWIN initial action done', 'font-size:2.5em')
            scroll_to_anchor();
            $(document).trigger('initial_done.plwin');
        }
        $(document).trigger('commands_done.plwin');

        check_duplicate_ids();
    } finally {
        enable_form();

        PageGen.query_in_progress = false;
        if (PageGen.action_queue.length > 0 ) {
            const [action, params] = PageGen.action_queue.shift();
            get_result(action, params);
        }

    }
};

let duplicate_ids = [];

function check_duplicate_ids() {
    $('[id][id!=""]').each(function () {
        if (duplicate_ids.includes(this.id)) {
            return;
        }
        let ids = $('[id="' + $.escapeSelector(this.id) + '"]');

        if (ids.length > 1) {
            duplicate_ids.push(this.id);
            console.error(`Duplicate ID: there are ${ids.length} elements with the ID "${this.id}"`);
        }
    });

}


function scroll_to_anchor() {
    let hash = document.location.hash;
    if (hash.length > 1) {
        hash = hash.slice(1);  // remove #

        let target = $(`#${hash}`);
        if (target.length == 0) {
            target = resolve_id(hash);
        }
        if (target.length == 0) {
            return;
        }

        target[0].scrollIntoView({behavior: 'smooth'});
    }
}


function process_command(container, cmd0, pos) {
    const cmd_type = typeof cmd0;
    if (cmd_type != 'string' && cmd_type != 'number' && !cmd0.hasOwnProperty('functor')) {
        throw `Invalid command object in result command of type ${cmd_type}:\n <code>`
            + escape_html(JSON.stringify(cmd0)) + '</code>';
    }
    const cmd =
        (cmd_type === 'object' && cmd0.hasOwnProperty('functor'))
        ? cmd0
        : (
            cmd0 === '\\\\'
            ? { functor: 'new_line', args: [] }
            : { functor: 'text', args: [cmd0] }
        );
    if (cmd.functor in PageGen.commands) {
        PageGen.container = container;
        PageGen.add_pos = pos;
        try {
            PageGen.commands[cmd.functor](cmd.args);
        } catch (err) {
            let cmd_str = escape_html(prolog_obj_to_str(cmd));
            throw `<hr>An error happened during the processing of <code>${cmd_str}</code>:

                ${err}`;
        }
    } else {
        throw 'Invalid command: <code>' + escape_html(cmd.functor)
            + '</code>. Details: <br><code>'
            + escape_html(prolog_obj_to_str(cmd))
            + '</code>';
    }
}

function add_elements(container, children, pos) {
    pos = pos || 'end';

    if (Array.isArray(children)) {
        if (pos == 'start' || pos == 'after') {
            children.reverse();
        }

        for (const child of children) {
            process_command(container, child, pos);
        }
    } else {
        process_command(container, children, pos);
    }
}

function add_element(element) {
    if (PageGen.add_pos == 'end') {
        PageGen.container.append(element);
        return PageGen.container.children().last();
    } else if (PageGen.add_pos == 'start') {
        PageGen.container.prepend(element);
        return PageGen.container.children().first();
    } else if (PageGen.add_pos == 'before') {
        PageGen.container.before(element);
        return PageGen.container.prev();
    } else if (PageGen.add_pos == 'after') {
        PageGen.container.after(element);
        return PageGen.container.next();
    }
    throw `Invalid adding position: <tt>${PageGen.add_pos}</tt>`;
}

function resolve_id(id, type='main') {
    let result;
    if (typeof id == 'string') {
        if (id === 'root') {
            console.warn('Deprecation: #root is being rename to #_root');
            id = '_root';
        }
        id = $.escapeSelector(id);
        result = $('#' + id);
        if (result.length != 1) {
            console.warn(`Could not find element with the id: "${escape_html(id)}" (type=${type})`);
        }
    } else if (id.functor && id.args && id.args.length) {
        const functor = id.functor;
        if (!(id.functor in PageGen.id_resolve_hooks)) {
            throw `No ID resolver hook for functor: ${escape_html(id.functor)}`;
        }
        result = PageGen.id_resolve_hooks[id.functor](id.args);
    } else {
        throw `Invalid element ID: <tt>${escape_html(JSON.stringify(id))}</tt>`;
    }

    switch(type) {
        case 'main':
            break;
        case 'child':
        case 'parent':
            if (result.data(`has-${type}-container`)) {
                let container = (type == 'child'
                                ? result.find('.child-container')
                                : result.parents('.parent-container')
                );
                if (container.length == 0) {
                    throw `Missing ${type} container for id '${id}'`;
                }
                result = $(container[0]);
            }
            break;
        default:
            throw `Invalid type '${type}' for resolve_id`;
    }
    return result;
}


$(document).on('commands_done.plwin', function(){
    setTimeout(() => {
        for (let elem of $('.prism-todo')) {
            Prism.highlightElement(elem, false,
                () => $(elem).removeClass('prism-todo')
            );
        }
    });
});


const PageGen = {
    container: null,
    add_pos: 'end',
    //root_container: null,

    /* after the first load([]) action is finished, the page is scrolled to the
     * anchor in the URL (if any) and this value will be true. */
    initialized: false,

    /* path of subpage, part of the URL after the module path */
    subpath: 'index',

    /* moduls should add a hook function that fetches key-value pairs of form
     * data from their respective elements */
    form_data_hooks: [],

    /* moduls should add a hook function that will resolve id-s with the key as
     * a functor */
    id_resolve_hooks: {},

    form_disabled: false,

    // User actions are queued and sent one at a time
    action_queue: [],

    // other querries will have to wait for it to finish
    query_in_progress: false,

    commands: {
        set_title: function(args) {
            document.title = args[0];
        },

        set_path: function(args) {
            console.warn('set_path/1 is deprecated, use set_page/1,2,3');
            let path = args[0];
            PageGen.subpath = path;
            let href = plwin_backend_root + plwin_module_path + '/' + path;
            if (href.indexOf('#') < 0) {
                href += document.location.hash;
            }
            window.history.pushState(null, '', href);
        },

        set_page: function(args) {
            const path = args[0];
            const title = args[1];
            const mode = args[2] || 'append';

            PageGen.subpath = path;

            let href = plwin_backend_root + plwin_module_path + '/' + path;
            if (href !== document.location.pathname) {
                if (href.indexOf('#') < 0) {
                    href += document.location.search + document.location.hash;
                }

                if (mode == 'append') {
                    window.history.pushState(null, '', href);
                } else if (mode == 'replace') {
                    window.history.replaceState(null, '', href);
                } else {
                    throw `Invalid set_page mode: '${mode}', allowed: append, replace`;
                }
            }

            if (title !== undefined && title !== null
                    && ! (Array.isArray(title) && title.length == 0)) {
                document.title = title;
            }
        },

        set_submit_action: function(args) {
            prolog_submit_action = args[0];
        },

        set_key_action: function(args) {
            const id = args[0];
            const action = args[1];
            const keys =
                Array.isArray(args[2])
                ? args[2]
                : get_argument(args, 'keys', []);

            const elem = id === '_root' ? $(document) : resolve_id(id);
            elem.keyup(function(evt) {
                console.log('key_act');
                console.log(evt);
                let modifiers = [
                    {functor: '-', args: ['alt', evt.altKey]},
                    {functor: '-', args: ['ctrl', evt.ctrlKey]},
                    {functor: '-', args: ['shift', evt.shiftKey]},
                ];
                if (action && (keys.length == 0 || keys.includes(evt.key))) {
                    submit_form([action, evt.key], {_modifiers: modifiers}
                    );
                    evt.stopPropagation()
                }
            });
        },

        set_timer: function(args) {
            const action = args[0];
            const seconds = args[1];

            setTimeout(
                () => { submit_form(action); },
                1000 * seconds
            );
        },

        set_leaving_warning: function(args) {
            const msg = args[0];
            prolog_unload_msg = msg;
        },


        scroll_element: function(args) {
            const elem = resolve_id(args[0]);
            const ratio = args[1];

            $(elem).animate({
                scrollTop: (elem[0].scrollHeight - elem.height()) * ratio
            }, {
                duration: "slow",
                queue: false
            });
        },
        scroll_page: function(args) {
            const ratio = args[0];

            $('html').animate({
                scrollTop: ($(document).height() - $(window).height()) * ratio,
            }, {
                duration: 'slow',
                queue: false
            });
        },
        scroll_page_to_element: function(args) {
            const elem = resolve_id(args[0]);
            const block = args[1] || 'top';
            elem[0].scrollIntoView({block: block, behavior: 'smooth'});
        },

        set_html_attribute: function(args) {
            const elem = resolve_id(args[0]);
            const attribute = args[1];
            const value = args[2];
            elem.attr(attribute, value);
        },

        set_field: function(args) {
            let field = resolve_id(args[0]);
            if (field.prop('type') == 'checkbox' || field.prop('type') == 'radio') {
                field.prop('checked', args[1]);
            } else {
                field.val(args[1]);
            }
        },

        set_disabled: function(args) {
            let elem = resolve_id(args[0]);
            let disabled = (args[1] === true || args[1] === undefined);

            $(elem).find('button,input,select,textarea').add(elem).prop('disabled', disabled);
        },

        focus: function(args) {
            const elem = resolve_id(args[0]);
            $('.focus').removeClass('focus');
            if (['BUTTON', 'INPUT', 'TEXTAREA'].includes(elem.prop('tagName'))) {
                elem.focus();
            } else {
                elem.addClass('focus');
                PageGen.commands.scroll_page_to_element([args[0], 'nearest']);
            }
        },

        wiggle: function(args) {
            const elem = resolve_id(args[0]);
            elem[0].animate([
                {transform: 'rotateZ(1deg)'},
                {transform: 'translate(2px,  0)    rotateZ(-1deg)'},
                {transform: 'translate(-2px, 2px)  rotateZ(-2deg)'},
                {transform: 'translate(2px, -2px)  rotateZ(-2deg)'},
                {transform: 'translate(0,    2px)  rotateZ(2deg)'},
                {transform: 'translate(2px,  0)    rotateZ(-1deg)'},
                {transform: 'translate(-2px, 2px)  rotateZ(-2deg)'},
                {transform: 'translate(2px, -2px)  rotateZ(-2deg)'},
                {transform: 'translate(0,    2px)  rotateZ(2deg)'},
                {transform: 'translate(0px,  0)    rotateZ(0deg)'}
            ], {
                iterations: 1,
                duration: 800,
                easing: 'ease'
            });

        },
        fadein: function(args) {
            const elem = resolve_id(args[0]);
            elem[0].animate([
                {opacity: 0},
                {opacity: 1}
            ], {
                iterations: 1,
                duration: 1200,
                easing: 'ease'
            });
        },
        flash: function(args) {
            const elem = resolve_id(args[0]);
            elem[0].animate([
                {offset: 0.5,   backgroundColor: '#ff9999' },
            ], {
                iterations: 1,
                duration: 800,
                easing: 'ease'
            });
        },

        text_area_resize: function(args) {
            var area = resolve_id(args[0]);
            area.attr('style', '');  // reset resizing done by the user
            area.attr('rows', args[1]);
            area.attr('cols', args[2]);
        },

        text_box_resize: function(args) {
            var box = resolve_id(args[0]);
            box.css('height', args[1] + 'px');
            box.css('width', args[2] + 'px');
        },

        delete: function(args) {
            var id = args[0];
            if (id == '_root') {
                throw 'You cannot delete the root container';
            }
            resolve_id(id, 'parent').remove();
        },

        empty: function(args) {
            var id = args[0];
            let container = resolve_id(args[0], 'child');
            container.empty();
        },

        append_children: function(args) {
            console.warn('%cDeprecation warning:', 'font-weight: bold',
                'append_children is renamed to add_elements');
            PageGen.commands.add_elements(args);
        },
        add_elements: function(args) {
            let target = args[0];
            let id, pos;
            if (typeof target == 'string') {
                id = target;
                pos = args[2] || 'end';
            } else if (target.functor && target.args.length == 1) {
                console.warn('%cDeprecation warning:', 'font-weight: bold',
                    'use add_elements(Id, Elems, [Pos]) instead of (Pos(Id), Elemes)');
                id = target.args[0];
                pos = target.functor;
            } else {
                throw `Invalid append target: ${target}`;
            }

            let container = resolve_id(id,
                ['start', 'end'].includes(pos)
                ? 'child'
                : 'parent'
            );

            add_elements(container, args[1], pos);
        },

        replace_element: function(args) {
            let id = args[0];
            let container = resolve_id(id, 'parent');

            add_elements(container, args[1], 'after');
            container.remove();
        },

        notification_get_permission: function(args) {
            if (window.Notification === undefined) {
                return;
            }
            Notification.requestPermission().then(
                (perm) => {
                    if (perm !== 'granted'
                        && window.pl_notification_alerted === undefined) {
                        alert('You have not allowed us to send notifications,'
                            + ' you might miss updates from the site.');
                        window.pl_notification_alerted = true;
                    }
                }
            );
        },
        notification_send: function(args) {
            if (window.Notification === undefined) {
                return;
            }
            const title = get_argument(args, 'title', "Hi there! 📡👀✅");
            const body =  get_argument(args, 'body', '✅Notifations seem to work!\n<i>Italic</i> <b>bold</b> \n🖥');
            new Notification(
                title, {
                    requireInteraction: true,
                    icon: "static/plwin.png",
                    data:'abc',
                    body: body,
                });
        },

        toggle_collapse: function(args) {
            const elem = resolve_id(args[0]);
            new Collapse(elem, {toggle: true});
        },

        modal_state: function(args) {
            const id = args[0];
            const state = args[1] || 'show';
            const mandatory = args[2] || false;

            const elem = $(`#${id}-modal`);

            const states = ['show', 'hide', 'toggle'];
            if (!states.includes(state)) {
                throw `Invalid modal state: ${state}, accepted: ${states.join(', ')}`;
            }
            const opts = {
                backdrop: mandatory ? 'static' : true,
                keyboard: !mandatory
            };
            const modal = Modal.getOrCreateInstance(elem, opts);
            modal[state]();
        },

        set_tooltip: function(args) {
            const id = args[0];
            const text = args[1];
            const show = args[2] || false;

            const elem = resolve_id(id);
            elem.attr('data-bs-title', text);
            elem.attr('data-bs-toggle', 'tooltip');
            const tooltip = new Tooltip(elem);
            if (show) {
                tooltip.show();
            }
        },

        text: function(args) {
            add_element(args[0]);
        },
        paragraph: function(args) {
            var id = args[0];
            var content = args[1];

            const par = add_element(`<p id="${id}"></p>`);
            add_elements(par, content);
        },
        new_line: function(args) {
            add_element('<br />');
        },
    }
};


function escape_atom(text) {
    return "'" + text.replace(/\\/g,'\\\\').replace(/'/g, "\\'") + "'";
}

function prolog_obj_to_str(obj) {
    if (Array.isArray(obj)) {
        return '[' + obj.map(prolog_obj_to_str).join(', ') + ']';
    } else if (typeof obj == 'object') {
        if (obj.functor === undefined) {
            throw 'Could not convert to atom: ' + JSON.stringify(obj);
        }

        if (['-', '/', '+', '='].includes(obj.functor) && obj.args.length == 2) {
            return prolog_obj_to_str(obj.args[0])
                + obj.functor
                + prolog_obj_to_str(obj.args[1]);
        } else {
            return prolog_obj_to_str(obj.functor)
                + '(' + obj.args.map(prolog_obj_to_str).join(', ') + ')';
        }
    } else if (typeof obj == 'string') {
        if (obj.length > 0 && /[a-z]/.test(obj[0]) && /^[a-zA-Z_]+$/.test(obj)) {
            return obj;
        } else {
            return escape_atom(obj);
        }
    } else {
        return String(obj);
    }
}


function get_argument(args, name, def) {
    const match = args.filter(
        (arg) => {
            return (arg.functor === '-'  || arg.functor === '=') && arg.args[0] == name;
        });
    if (match.length > 0) {
        return match[0].args[1];
    }
    const last = args[args.length - 1];
    if (Array.isArray(last)) {
        const match = last.filter(
            arg => { arg.functor == name; });
        if (match.length > 1) {
            throw `${name} optional arg specified multiple times!`;
        } else if (match.length == 1) {
            return match[0].args[0];
        }
        const match2 = last.filter(
            arg => { ['-', '='].includes(arg.functor) && arg.args[0] == name; });
        if (match2.length > 1) {
            throw `${name} optional arg specified multiple times!`;
        } else if (match2.length == 1) {
            return match2[0].args[1];
        }
    }

    return def;
}

function escape_html(html) {
    return html
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function handle_error(evt) {
    console.log('error: ', JSON.stringify(evt));
    console.log('error: ', evt);
    console.log('error: ', {...evt});
    let msg = '', type = '';
    if ('message' in evt) {
        msg = evt.message;
        type = 'JavaScript error'
    } else if (evt.event == 'failure') {
        msg = 'The sent Prolog goal failed.';
        type = 'Prolog failure'
    } else if (evt.event !== undefined) {
        msg = `<b><tt>${evt.code}</tt></b>: ` + escape_html(evt.data);
        type = 'Prolog error'
    } else {
        msg = escape_html(evt.data);
        type = 'JavaScript error'
    }
    if ('type' in evt) {
        type = evt.type;
    }
    PageGen.query_in_progress = false;

    const error_text = msg
        .replace(/\n/g, '<br />')
        .replace(/\\n/g, '<br />');
    $('#_errors').append(`
        <div class="alert alert-danger alert-dismissible fade show" role="alert">
            <h4 class="alert-heading">${type}</h4>
            <button type="button" class="btn-close close" data-bs-dismiss="alert" aria-label="Close">
            </button>
            <hr>

            <p class="msg">${error_text}</p>
        </div>
    `);

    enable_form();
}

export default PageGen;
export {PageGen, get_argument, resolve_id};
if (typeof window === 'undefined') {
    module.exports = PageGen;
}
